import { ComponentChild, h, JSX } from 'preact'
import { common } from '../common'
import TitleInput from '../title-input/TitleInput'
import { CustomButton } from '../header'
import OverviewSwitcher from '../ui-components/OverviewSwitcher'
import BetaBadge from '../ui-components/BetaBadge'

interface Props {
  type: string,
  isCustomView: boolean,
  title: string,
  isBeta?: boolean,
  onTitleChanged: (title: string) => void,
  customButtons?: Array<CustomButton | ComponentChild>,
  customViewActions?: JSX.Element
}

const Header = (
  {
    type,
    isCustomView,
    title,
    onTitleChanged,
    customButtons,
    isBeta = false,
    customViewActions
  }: Props) => {
  return (
    <div>
      <div class='control-header'>
        {isCustomView
          ? <TitleInput title={title} onTitleChanged={onTitleChanged} />
          : <h2 class='control-header__title'>{title}{common.isModuleActive('moderationOverviewBetaDefault') && <OverviewSwitcher />}{isBeta && <BetaBadge />}</h2>
        }
        { customViewActions }
        { customButtons && <div className='control-header__action-buttons'>{customButtons}</div> }
      </div>
    </div>
  )
}

export default Header
